module.exports = __webpack_public_path__ + "img/products-5.ed978fe4.png";